import clsx from "clsx"
import style from "./style.module.scss"

import type { FC } from "react"

type Props = {
  gutterTop?: boolean
  rows?: number
}

const Skeleton: FC<Props> = ({ gutterTop, rows = 6 }) => {
  return (
    <div className={clsx(style.skeleton, { [style.gutterTop]: gutterTop })}>
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index.toString()} />
      ))}
    </div>
  )
}

export default Skeleton
